import React from 'react';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
interface RegistrationDateScreenProps {
  registrationDate: string;
  onChange: (field: string, value: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export function RegistrationDateScreen({
  registrationDate,
  onChange,
  onNext,
  onBack
}: RegistrationDateScreenProps) {
  const isValid = registrationDate !== '';
  return <div className="flex flex-col h-full max-w-md mx-auto pt-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-280">
      <div className="flex-1" data-id="element-281">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-282">
          Registration Date
        </h2>
        <p className="text-gray-500 mb-8" data-id="element-283">
          When was your business officially registered?
        </p>

        <div className="space-y-6" data-id="element-284">
          <Input type="date" label="Date of Registration" value={registrationDate} onChange={e => onChange('registrationDate', e.target.value)} autoFocus data-id="element-285" />
        </div>
      </div>

      <div className="flex gap-4 mt-8 pb-8" data-id="element-286">
        <Button variant="secondary" onClick={onBack} className="w-1/3" data-id="element-287">
          Back
        </Button>
        <Button variant="primary" onClick={onNext} disabled={!isValid} className="w-2/3" data-id="element-288">
          Continue
        </Button>
      </div>
    </div>;
}